import CustomBreadcrumbs from "../components/CustomBreadcrumbs";
import {Helmet} from "react-helmet-async";
import React, {useState} from "react";
import {
  Box, Button,
  makeStyles,
  Typography as MuiTypography
} from "@material-ui/core";
import CompanyForm from "../components/company-form/CompanyForm";
import {createCompany, updateCompanyFormData} from "../../../../services/companyService";
import {useDispatch, useSelector} from "../../../../redux/store";
import {getUser} from "../../../../selectors";
import * as types from "../../../../constants";
import {capitalize} from "../../../../utils/functions";
import { useHistory } from 'react-router-dom';
import {createCompanyAPIKey} from "../../../../services/companyAPIKeysService";

const useStyles = makeStyles(theme => ({
  title: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "24px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  }
}))

const CreateCompanyPage = () => {
  const history = useHistory();
  const user = useSelector(getUser);
  const styles = useStyles();
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  const handleSubmit = (values: any) => {
    setLoading(true)
    const data = {
      name: values.name,
      email: values.email,
      registration_number: values.registration_number,
      nr_employees: values.nr_employees,
      hubspot_company_id: values.hubspot_company_id,
      type: values.type,
      logo: values.logo,
      address: values.address,
      supported_a11y_standards: values.supported_a11y_standards,
      supported_languages: values.supported_languages,
      is_live_user: true
    }
    const {logo, ...other} = data
    createCompany(other, user!.token).then((response) => {
      if (values.company_api_key) {
        const companyApiKey = {
          ...values.company_api_key,
          expiry_date: values.company_api_key.expiry_date.includes('T') ? values.company_api_key.expiry_date : `${values.company_api_key.expiry_date}T00:00:00Z`,
          company: response.data.id
        }
        createCompanyAPIKey(companyApiKey, user!.token)
      }
      if (logo) {
        updateCompanyFormData(response.data.id, {logo: logo}, user!.token).then((r) => {
          dispatch({
            type: types.ADD_TOAST,
            payload: {type: 'success', message: 'The company has been successfully created'}
          })
          history.goBack()
          setLoading(false)
        })
      } else {
        dispatch({
          type: types.ADD_TOAST,
          payload: {type: 'success', message: 'The company has been successfully created'}
        })
        history.goBack()
        setLoading(false)

      }
    }).catch((err) => {
      const keys = Object.keys(err)
      keys.forEach((k) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: {type: 'error', name: k, message: capitalize(err[k][0])}
        })
      })
      setLoading(false)
    })
  }

  return (
    <Box p={12}>
      <Helmet title={'New company'} />
      <MuiTypography className={styles.title} variant="h3" gutterBottom display="inline">
        Companies list
      </MuiTypography>
      <CustomBreadcrumbs data={[
        {name: 'Companies', link: '/companies'},
        {name: 'New company', link: '/create-new-company'}
      ]}/>
      <CompanyForm onSubmit={handleSubmit} loading={loading}/>
    </Box>
  )
}

export default CreateCompanyPage